import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Modal, Button, Stack, TextField, Checkbox, Typography } from '@mui/material';
import { updateGenericData } from './api';
import { cores, labelCampoEscuro } from '../styles/styleUtils';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50vw',
  height: '95vh',
  '@media screen and (max-width: 600px)': {
    width: '50vw', // Width de 100% para telas de celulares
    height: '95vh',
  },
  bgcolor: 'transparent',
  border: `1px solid ${cores.chumbo}`, borderTop: `4px solid ${cores.laranja}`,
  boxShadow: 24,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  background: `linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%)`,
  alignItems: 'center',
  justifyContent: 'center',
};

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const ModalAddEmissorBoleto = React.forwardRef((props, ref) => {
  const [data, setData] = useState(props.dataSelected);

  const handleChange = (e) => {
    setData({ ...data, [e.target.id]: e.target.value });
  };

  const saveData = async () => {
    await updateGenericData('bancoemissor', data);
    props.onConfirm();
  };

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} gap={2}>
        <TextField
          id="nome"
          label="Nome"
          variant="outlined"
          value={data?.nome}
          onChange={handleChange}
          sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
        />

        <TextField
          type="number"
          id="taxaEmissao"
          label="Taxa Emissão (R$)"
          variant="outlined"
          value={data?.taxaEmissao}
          onChange={handleChange}
          sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
        />

        <TextField
          type='number'
          id="taxaAntecipacao"
          label="Taxa Antecipação (%)"
          variant="outlined"
          value={data?.taxaAntecipacao}
          onChange={handleChange}
          sx={{ width: '70%', backgroundColor: 'white', ...labelCampoEscuro, mt: 1 }}
        />

        <Stack direction={'row'}>
          <Checkbox
            checked={data?.ativo}
            onChange={() => setData({ ...data, ativo: !data.ativo })}
            inputProps={{ 'aria-label': 'controlled' }}
            sx={{ color: 'rgba(255,255,255,0.7)', '&.Mui-checked': { color: cores.laranja } }}
          />
          <Typography mt={1} sx={{ color: cores.textoClaro }}>Ativo</Typography>
        </Stack>
        <Stack direction={'row'} justifyContent={'space-between'} gap={20} mt={0}>
          <Button variant="outlined" onClick={props.onClose} color="error">
            {' '}
            Cancelar
          </Button>
          <Button variant="contained" color="success" onClick={saveData}>
            Salvar
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
});

ModalAddEmissorBoleto.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default ModalAddEmissorBoleto;